// Components
import { Creatable } from '../../../molecules/advancedSelect';

// Containers
import withSelectInput from '../hoc/withSelectInput';
export default withSelectInput(Creatable);